	import React, { Fragment } from 'react';
	import ReactDOM from 'react-dom';
	import LoggedInPage from '../../views/core/LoggedInPage';
	import Iframe from 'react-iframe';
	import $ from 'jquery';
	import '../../css/GetTest.css';
	import HmAjax from '../../util/HmAjax';
	import Pagination from 'react-ultimate-pagination-material-ui';
	import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
	import { confirmAlert } from 'react-confirm-alert'; // Import
	import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

	// import CircularProgressbar from 'react-circular-progressbar';
	import 'react-circular-progressbar/dist/styles.css';
	import HmEventRegistry from '../../model/HmEventRegistry';



	import AlertManager from '../../util/AlertManager';
	import CircularVideoBuffer from '../../util/CircularVideoBuffer';

	class ContestGetTest extends LoggedInPage {

	constructor(props) {
		super(props);
		this.displayTextObj = {};
		this.displayTextObj.solutionTitle = this.rb("editor.solutionTitle");
		this.displayTextObj.answerTitleSingle = "";
		this.displayTextObj.answerTitlePlural = "";
		this.displayTextObj.showEditorTooltip = this.rb("editor.showEditorTooltip");
		this.displayTextObj.hideEditorTooltip = this.rb("editor.hideEditorTooltip");
		this.displayTextObj.enterAnswerMessage = this.rb("editor.enterAnswerMessage");

	//var iframeContentUrl = this.getUrlFor("IFRAME_DOMAIN") + "/prassoapp/20171102/";
	//console.log(this.props.topicInfoObj);
	//console.log("currentQNo="+this.props.topicInfoObj.userTest.currentQNo);
	this.testCompleted = false;
	this.showSolution = false;

	this.currentQuestionNo=(!isNaN(props.topicInfoObj.currentQNo) && props.topicInfoObj.currentQNo > 0 && (props.topicInfoObj.currentQNo <= props.topicInfoObj.questionCount)) ? (props.topicInfoObj.currentQNo) : 1;

	this.allMediaChunks = [];

	this.state = {
		pageCurrent: (this.props.topicInfoObj.testMode==1) ? this.currentQuestionNo : this.props.topicInfoObj.currentAttempt,
		currentAttempt: (this.props.topicInfoObj.testMode==1) ? this.currentQuestionNo : this.props.topicInfoObj.currentAttempt ,
		/*currentQuesNo:(this.props.topicInfoObj.testMode==1) ? 1 : this.props.topicInfoObj.currentQNo,*/
		currentQuesNo: this.currentQuestionNo,
		pageTotal: this.props.topicInfoObj.questionCount,
		totalQuestions:this.props.topicInfoObj.questionCount,
		paginationDisabled:false,
		percentageComplete:0,
		testMode:this.props.topicInfoObj.testMode,
		questionObj:[],
		questionRendered:false,
		attemptedQuestions:this.props.topicInfoObj.attempts || new Object(),
		questionEvaluated:false,
		showSolution:this.showSolution,
		testCompleted:this.testCompleted,
		isRecording:false,
		recordingTime:0,
		recordingError:null
	};

	this.onPageChange = this.onPageChange.bind(this);
	this.handleManualVideoSubmit = this.handleManualVideoSubmit.bind(this);

	this.handleMessage = this.handleMessage.bind(this);
	this.iframeLoaded = this.iframeLoaded.bind(this);
	this.getQuestion = this.getQuestion.bind(this);
	this.modalCloseEvent = this.modalCloseEvent.bind(this);
	this.submitClick = this.submitClick.bind(this);
	this.EvaluateClick = this.EvaluateClick.bind(this);
	this.NextClick = this.NextClick.bind(this);
	this.PrevClick = this.PrevClick.bind(this);
	this.SaveClick = this.SaveClick.bind(this);
	this.viewHideSolutionClick = this.viewHideSolutionClick.bind(this);
	this.startScreenRecording = this.startScreenRecording.bind(this);
	this.stopScreenRecording = this.stopScreenRecording.bind(this);
	this.uploadRecordedVideo = this.uploadRecordedVideo.bind(this);
	this.testManualUpload = this.testManualUpload.bind(this);
	this.formatTime = this.formatTime.bind(this);
	this.submitPractice = this.submitPractice.bind(this);
	this.enableQuestionTrackTimer = false;
	this.intervalId = null;
	this.checkImageLoaded = this.checkImageLoaded.bind(this);
	this.trackTestClose = this.trackTestClose.bind(this);

	//this.markAttemptedQuestions = this.markAttemptedQuestions.bind(this);

	this.forceSubmit = false;
	this.attemptBeforeEvaluate = null;

	this.prassoView = null;
	this.isPrassoViewLoaded = false;
	this.evalAndNavigate = false;
	this.evalAndSubmit = false;
	this.isSubmitTriggered = false;
	this.submittedQnMap = new Object();

	this.correctAns = false;
	this.solutionResults = [];
	this.attemptsLeft;
	this.allowedAttempts;
	this.currentAttempt;

	this.seenQnCount = 0;
	this.completedQuestionCnt;
	this.totalNoQuestions=0;

	this.isEvaluationGoing = false;
	this.currTestQuestionId = null;
	this.currentSnippetId = null;
	this.questionAnswerStartTime = null;
	this.questionAnswerElapsedTime = null;
	this.timeSpentAction="";
	this.currentRating = null;
	this.allQuestions= [];

	this.iframeContentDomain = null;//"http://local.retailmath.com:3000/";
	//const UltimatePagination = reactUltimatePaginationBasic.default;  	

	this.trackingQuestionObj = {};
	this.questionLoadTime = null;
	this.questionStart = 1;
	this.nextQuestionNo = 0;

	//This var is responsible for 
	//this.attemptedQuestionIndices = new Set();

	this.canMoveToNextQuestion = false;
	}

	/*
	* IMPORTANT: This is for the very last question attempted by the user.
	* Auto-submission will still work from TimerComp irrespective of the configuration window.auto_submit_types - FOR NOW
	*/
	isAutoSubmitAllowed(){
		try{
			let testType = this.props.topicInfoObj.testType;

			if(window.auto_submit_types && window.auto_submit_types.length > 0){
				return (~window.auto_submit_types.indexOf(testType)) ? true:false;
			}
		}catch(e){
			console.error(e);
		}

		return false;
	}

	setTmpQuestionNo(tmpQuestionNo){
		this.tmpQuestionNo = (!isNaN(tmpQuestionNo) && tmpQuestionNo > 0 && tmpQuestionNo <= this.getTotalQuestions()) ? tmpQuestionNo: this.currentQuestionNo;
	}

	getTmpQuestionNo(){
		return this.tmpQuestionNo;
	}

	getCurrentQuestionNo(){
		return this.currentQuestionNo;
	}

	getTotalQuestions(){
		return this.totalNoQuestions;
	}

	forceSubmitMode(testMode){
		if(!isNaN(testMode) && window.force_submit_test_mode){
			return ~window.force_submit_test_mode.indexOf(testMode) ? true: false;
		}

		return false;
	}

	onCloseHandler(){
		if(!this.isAjaxSubmitTriggered && (this.forceSubmitMode(this.state.testMode) || this.isAutoSubmitAllowed()) && this.getCurrentQuestionNo() > this.getTotalQuestions()){	
			this.completeTest();
		}else{
			//this.triggerGetUserAnswer();
			console.warn("This test is not eligible for submit on close.");
		}
	}

	prevchangeEvent(page){
	//this.getQuestion();
	this.timeSpentAction = "Pagination";
	this.evalAndNavigate = true;
	this.evalAndSubmit = false;

	let currClickQues = page || this.getCurrentQuestionNo();
	if(!page){
		page = currClickQues - 1;		
	 }	 
	 this.setTmpQuestionNo(page);
	 this.setState({pageCurrent:page, paginationDisabled:true});

	this.nextQuestionNo = page;

	this.evalAns();
	// const me = this;
	// 	setTimeout(() => {
	// 		me.markAttemptedQuestions();
	// 	}, 1500); 
	}
	changeEvent(page){
	//this.getQuestion();
	this.timeSpentAction = "Pagination";
	this.evalAndNavigate = true;
	this.evalAndSubmit = false;

	let currClickQues = page || this.getCurrentQuestionNo();
	if(!page){
		page = currClickQues + 1;		
	 }	 
	 this.setTmpQuestionNo(page);
	 this.setState({pageCurrent:page, paginationDisabled:true});

	this.nextQuestionNo = page;

	this.evalAns();
	// const me = this;
	// 	setTimeout(() => {
	// 		me.markAttemptedQuestions();
	// 	}, 1500); 
	}

	onPageChange(page) {  
		if(this.canMoveToNextQuestion){
			this.changeEvent(page);	
		}else{
			console.warn("cannot move to a differeng question until current one is rendered.");
		}		 	
	} 

	evalAns(){
	this.showSolution = false;
	this.correctAns = false;
	this.solutionResults = undefined;
	this.setState({showSolution:false});
	this.prassoView.postMessage({name:"getUserAnswer"}, this.iframeContentDomain);
	}
	iframeLoaded(){	   
	if(!this.container){
		this.container = document.getElementById("quesIframe");
	}

	const iframeDOMNode = ReactDOM.findDOMNode(this.container)
	this.prassoView = iframeDOMNode.contentWindow;

	this.isPrassoViewLoaded = true;
	if(this.prassoView){    	
		this.isAjaxSubmitTriggered = false;
		this.prassoView.postMessage({name:"setDisplayText",params:[this.displayTextObj]}, this.iframeContentDomain);
		if(this.state.testMode == 1){	
				//this.prassoView.enableTestMode();
				this.prassoView.postMessage({name:"enableTestMode"}, this.iframeContentDomain);
			}
		}


		if(this.state.testMode == 1){
			this.getQuestion();	
		}
		else{
			//console.log("tot ques ",this.currentQuestionNo,this.totalNoQuestions);
			if (this.currentQuestionNo > this.totalNoQuestions) {
				this.setState({testCompleted:true});
				this.completeTest(true);
			} else {
				this.getQuestion();	  
			}
		}
	}
	componentDidMount(){		
		this.questionAnswerStartTime = null;
		this.questionAnswerElapsedTime = null;
		this.enableQuestionTrackTimer = false;
		clearInterval(this.intervalId);
		window.addEventListener('contestTriggerVideoSubmit', this.handleManualVideoSubmit);
		this.initiateQuestionPulseTimer();
		this.currentRating = null;
		this.props.onRef(this);
	   //console.log(this.props.topicInfoObj);
	   this.currentAttempt = (this.props.topicInfoObj.testMode==1) ? 1 : this.props.topicInfoObj.currentAttempt;
	   this.currentQuestionNo=(!isNaN(this.props.topicInfoObj.currentQNo) && this.props.topicInfoObj.currentQNo > 0 && (this.props.topicInfoObj.currentQNo <= this.props.topicInfoObj.questionCount)) ? (this.props.topicInfoObj.currentQNo) : 1;
	   ///this.currentQuestionNo = (this.props.topicInfoObj.testMode==1) ? 1 : this.props.topicInfoObj.currentQNo;
	   this.completedQuestionCnt = this.props.topicInfoObj.completedQnCount || 0;
	   this.seenQnCount = this.props.topicInfoObj.seenQnCount || 0;
	   this.totalNoQuestions = this.props.topicInfoObj.questions.length || 0;
	   

	   this.currentQuestionId = this.props.topicInfoObj.currentQuestionId || 0;

	   this.attemptsLeft = -1;
	   
	   if(this.state.attemptedQuestions){
	   	this.submittedQnMap = this.state.attemptedQuestions;
	   }
	   this.iframeContentDomain = this.getBasePath();
	   
	   window.addEventListener('message', this.handleMessage, false);
	   
	   if(!this.container){
	   	this.container = document.getElementById("quesIframe");
	   }

	   let iframeDOMNode = ReactDOM.findDOMNode(this.container);
	   
	   iframeDOMNode.addEventListener('load', this.iframeLoaded);
	   
	// const me = this;
	// 	setTimeout(() => {
	// 		me.markAttemptedQuestions();
	// 	}, 2000);  	

	   HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  
	   this.startScreenRecording(this.props.topicInfoObj && this.props.topicInfoObj.preCapturedStream);
	}
	componentWillUnmount(){
		this.props.onRef(undefined);
		window.removeEventListener('message', this.handleMessage, false);
		window.removeEventListener('contestTriggerVideoSubmit', this.handleManualVideoSubmit);
		this.stopScreenRecording();
	}

	loadProctorSettings() {
		const defaultSettings = {
			version: "v2",
			preAlertBufferMinutes: 0.5,
			postAlertBufferMinutes: 1,
			timesliceSeconds: 5,
			videoBitsPerSecond: 250000,
			maxStrikes: 3,
			cooldownSeconds: 3,
			showAlert: true,
			oneAlertPerWindow: false,
			showPostVideoButton: true,
			showVideoButtons: true,
			showDebugUploadButton: false,
			enableLegacyFullRecording: false
		};

		if (window.PROCTOR_SETTINGS) {
			return Promise.resolve(window.PROCTOR_SETTINGS);
		}

		const settingsUrl = '/settings.json?v=' + Date.now();
		return fetch(settingsUrl, { cache: 'no-store' })
			.then(response => {
				if (!response.ok) throw new Error("settings.json returned status " + response.status);
				return response.json();
			})
			.then(data => {
				const cfg = (data && data.proctoring) ? data.proctoring : (data || {});
				window.PROCTOR_SETTINGS = Object.assign({}, defaultSettings, cfg);
				console.log("⚙️ [ContestGetTest] Loaded settings.json:", window.PROCTOR_SETTINGS);
				return window.PROCTOR_SETTINGS;
			})
			.catch(err => {
				console.warn("⚠️ [ContestGetTest] Using default proctoring settings:", err);
				window.PROCTOR_SETTINGS = defaultSettings;
				return defaultSettings;
			});
	}

	startScreenRecording(existingStream){
		const me = this;

		if (!me.allMediaChunks) {
			me.allMediaChunks = [];
		}

		const setupStream = (stream) => {
			const videoTrack = stream && stream.getVideoTracks() ? stream.getVideoTracks()[0] : null;
			const trackSettings = videoTrack && videoTrack.getSettings ? videoTrack.getSettings() : {};
			const surface = trackSettings.displaySurface;

			if (surface && surface !== 'monitor') {
				try {
					stream.getTracks().forEach(t => t.stop());
				} catch(e) {}
				me.setState({
					isRecording: false,
					recordingError: "Access Denied: You selected '" + surface + "'. You MUST share your Entire Screen to take this contest test!"
				});
				return;
			}

			me.mediaStream = stream;

			if (stream && stream.getVideoTracks() && stream.getVideoTracks()[0]) {
				stream.getVideoTracks()[0].onended = () => {
					if (!me.isSubmitting) {
						me.setState({
							isRecording: false,
							recordingError: "Screen sharing was stopped. Click 'Resume Screen Sharing' to unlock and continue the test."
						});
					}
					if (me.recordingTimer) {
						clearInterval(me.recordingTimer);
					}
				};
			}

			me.loadProctorSettings().then(settings => {
				const preAlertSec = (settings.preAlertBufferMinutes !== undefined && settings.preAlertBufferMinutes !== null ? Number(settings.preAlertBufferMinutes) : 2) * 60;
				const postAlertSec = (settings.postAlertBufferMinutes !== undefined && settings.postAlertBufferMinutes !== null ? Number(settings.postAlertBufferMinutes) : 3) * 60;
				const timesliceMs = (settings.timesliceSeconds || 5) * 1000;
				const videoBitrate = settings.videoBitsPerSecond || 250000;

				const topicInfo = me.props.topicInfoObj || {};
				const contestId = topicInfo.contestId || 0;
				const userTestId = topicInfo.userTestId || 0;
				const testId = topicInfo.testId || 0;

				// Initialize Global Video Upload Tracker for console inspection
				if (!window.videoUploadTracker || window.videoUploadTracker.contestId !== contestId) {
					window.videoUploadTracker = {
						totalCreated: 0,
						totalUploaded: 0,
						pendingUploads: 0,
						failedUploads: 0,
						contestId: contestId,
						testId: testId,
						userTestId: userTestId,
						videos: [],
						getSummary: function() {
							return `${this.totalUploaded} of ${this.totalCreated} video(s) uploaded to server.`;
						},
						list: function() {
							if (console && console.table) {
								console.table(this.videos.map(v => ({
									Index: v.clipIndex,
									Filename: v.filename,
									Size: v.sizeFormatted,
									Status: v.status,
									AlertType: v.alertType,
									Duration: v.durationSeconds ? v.durationSeconds.toFixed(1) + 's' : 'N/A',
									UploadedAt: v.uploadedTime || 'Pending'
								})));
							} else {
								console.log(this.videos);
							}
							return this.getSummary();
						}
					};
					window.uploadedVideos = window.videoUploadTracker.videos;
					window.uploadedVideosCount = 0;
				}

				me.setState({
					showDebugUploadButton: !!settings.showDebugUploadButton
				});

				// Initialize Version 2 Alert Manager
				if (!me.alertManager) {
					me.alertManager = new AlertManager({
						maxStrikes: settings.maxStrikes || 3,
						cooldownMs: (settings.cooldownSeconds || 3) * 1000,
						showAlert: settings.showAlert !== false,
						oneAlertPerWindow: !!(settings.oneAlertPerWindow || settings.OneAlertPerWindow),
						isWindowActive: () => me.circularBuffer && me.circularBuffer.isIncidentActive(),
						getTestQuestionId: () => (me.state.questionObj && me.state.questionObj.id) || me.state.currentQuesNo || 1,
						getElapsed: () => (me.formatTime ? me.formatTime(me.state.recordingTime || 0) : '00:00'),
						onAlert: (alertRecord) => {
							console.warn("🚨 [ContestGetTest] Proctoring Alert detected:", alertRecord);
						if (me.circularBuffer) {
							me.circularBuffer.triggerAlert(alertRecord);
						}
					}
				});
			}
			me.alertManager.startMonitoring();

			// Initialize Version 2 Circular Rolling Buffer (variable pre-buffer + post-buffer)
			if (!me.circularBuffer) {
				me.circularBuffer = new CircularVideoBuffer(stream, {
					maxBufferSeconds: preAlertSec,
					postAlertSeconds: postAlertSec,
					timesliceMs: timesliceMs,
					videoBitsPerSecond: videoBitrate,
					onEvidenceReady: (clipResult) => {
						console.log("🚨 [ContestGetTest] Evidence clip ready, initiating upload:", clipResult);
						clipResult.uploadPromise = me.uploadAlertEvidence(clipResult.blob, clipResult.alertMeta, clipResult.markerOffsetSeconds, clipResult);
					}
				});
			}
			me.circularBuffer.start();

			// Optional Legacy V1 Full Recording (disabled by default in settings.json)
			if (settings.enableLegacyFullRecording) {
				let options = { mimeType: 'video/webm' };
				if (typeof MediaRecorder !== 'undefined' && MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
					options = { mimeType: 'video/webm;codecs=vp9' };
				}

				me.mediaRecorder = new MediaRecorder(stream, options);

				me.mediaRecorder.ondataavailable = (event) => {
					if (event.data && event.data.size > 0) {
						me.allMediaChunks.push(event.data);
					}
				};

				me.mediaRecorder.onstop = () => {
					console.log("🎥 Session MediaRecorder stopped. Total accumulated chunks:", me.allMediaChunks ? me.allMediaChunks.length : 0);
				if (me.allMediaChunks && me.allMediaChunks.length > 0) {
					const blob = new Blob(me.allMediaChunks, { type: 'video/webm' });
					console.log("🎥 Auto-uploading master video blob from onstop, size:", blob.size);
					me.uploadRecordedVideo(blob);
				}
			};

				me.mediaRecorder.start(1000);
			}

			if (me.recordingTimer) {
				clearInterval(me.recordingTimer);
			}

			me.recordingTimer = setInterval(() => {
				me.setState((prevState) => {
					const newTime = prevState.recordingTime + 1;
					try {
						window.dispatchEvent(new CustomEvent('recordingStateUpdate', { detail: { isRecording: true, recordingTime: newTime } }));
					} catch(e) {}
					return { recordingTime: newTime };
				});
			}, 1000);

			me.setState({
				isRecording: true,
				recordingError: null
			});

			try {
				window.dispatchEvent(new CustomEvent('recordingStateUpdate', { detail: { isRecording: true, recordingTime: me.state.recordingTime } }));
			} catch(e) {}
			});
		};

		if (existingStream && existingStream.active && existingStream.getVideoTracks() && existingStream.getVideoTracks().length > 0) {
			setupStream(existingStream);
			return;
		}

		if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
			me.setState({ recordingError: "Screen recording is not supported in this browser." });
			return;
		}

		navigator.mediaDevices.getDisplayMedia({
			video: { displaySurface: 'monitor' },
			audio: true
		}).catch(() => {
			return navigator.mediaDevices.getDisplayMedia({ video: { displaySurface: 'monitor' } });
		}).then((stream) => {
			setupStream(stream);
		}).catch((err) => {
			console.error("Screen recording permission error:", err);
			me.setState({
				isRecording: false,
				recordingError: "Screen recording permission was canceled. Click 'Resume Screen Sharing' to activate."
			});
			try {
				window.dispatchEvent(new CustomEvent('recordingStateUpdate', { detail: { isRecording: false, recordingTime: 0 } }));
			} catch(e) {}
		});
	}

	stopScreenRecording(){
		if (this.recordingTimer) {
			clearInterval(this.recordingTimer);
		}
		if (this.alertManager) {
			this.alertManager.stopMonitoring();
		}
		if (this.circularBuffer) {
			if (this.alertManager && this.alertManager.hasAlerts()) {
				const flushedClip = this.circularBuffer.flushPendingEvidence();
				if (flushedClip && flushedClip.blob && !flushedClip.uploadPromise) {
					this.uploadAlertEvidence(flushedClip.blob, flushedClip.alertMeta, flushedClip.markerOffsetSeconds, flushedClip);
				}
			} else {
				console.log("🧹 [ContestGetTest] Clean test completed (0 alerts). Video buffer discarded (0 bytes uploaded).");
			}
			this.circularBuffer.destroy();
		}
		if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
			try {
				this.mediaRecorder.stop();
			} catch(e) {}
		}
		if (this.mediaStream) {
			try {
				this.mediaStream.getTracks().forEach(track => track.stop());
			} catch(e) {}
		}
		this.setState({ isRecording: false });
		try {
			window.dispatchEvent(new CustomEvent('recordingStateUpdate', { detail: { isRecording: false, recordingTime: 0 } }));
		} catch(e) {}
	}

	uploadRecordedVideo(passedBlob){
		const me = this;

		if (me.isUploading && me.uploadPromise) {
			console.log("ℹ️ Video upload already in progress, reusing active upload request...");
			return me.uploadPromise;
		}

		const topicInfo = me.props.topicInfoObj || {};
		const contestId = topicInfo.contestId || 0;
		const userTestId = topicInfo.userTestId || 0;
		const testId = topicInfo.testId || 0;

		let videoBlob = passedBlob;

		if (!videoBlob || !(videoBlob instanceof Blob)) {
			const chunksToUpload = (me.allMediaChunks && me.allMediaChunks.length > 0) ? me.allMediaChunks : (me.mediaChunks || []);
			if (!chunksToUpload || chunksToUpload.length === 0) {
				console.warn("⚠️ No video chunks available to upload.");
				return Promise.resolve(null);
			}
			videoBlob = new Blob(chunksToUpload, { type: 'video/webm' });
		}

		const videoFilename = `contest_test_${testId}_${Date.now()}.webm`;
		const formData = new FormData();
		formData.append('video', videoBlob, videoFilename);
		formData.append('contestId', contestId);
		formData.append('userTestId', userTestId);
		formData.append('testId', testId);

		console.log("🚀 Uploading master screen recording:", { contestId, userTestId, testId, size: videoBlob.size });

		try {
			const videoUrl = URL.createObjectURL(videoBlob);
			console.log("🎬 Local Master Recorded Video Preview URL:", videoUrl);
			window.latestRecordedVideoUrl = videoUrl;
			window.latestRecordedVideoBlob = videoBlob;
			window.latestRecordedVideoFilename = videoFilename;

			if (typeof indexedDB !== 'undefined') {
				const dbReq = indexedDB.open("ContestProctorDB", 1);
				dbReq.onupgradeneeded = function(e) {
					const db = e.target.result;
					if (!db.objectStoreNames.contains("recordings")) {
						db.createObjectStore("recordings");
					}
				};
				dbReq.onsuccess = function(e) {
					try {
						const db = e.target.result;
						const tx = db.transaction("recordings", "readwrite");
						const store = tx.objectStore("recordings");
						store.put(videoBlob, "latest_recording");
						store.put(videoFilename, "latest_recording_filename");
					} catch(err) {}
				};
			}
		} catch(e) {}

		const uploadEndpoint = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.includes('local'))
			? (window.location.protocol + "//" + window.location.hostname + ":8701/uploadVideo")
			: "/api/contest/uploadVideo";

		me.isUploading = true;
		me.uploadPromise = new Promise((resolve) => {
			const xhr = new XMLHttpRequest();
			xhr.open('POST', uploadEndpoint, true);

			xhr.onload = function() {
				me.isUploading = false;
				me.uploadPromise = null;
				if (xhr.status >= 200 && xhr.status < 300) {
					try {
						const response = JSON.parse(xhr.responseText);
						console.log("✅ Screen recording video uploaded successfully:", response);
						resolve(response);
					} catch(e) {
						resolve({ status: 'success', raw: xhr.responseText });
					}
				} else {
					console.error("❌ Video upload failed with status:", xhr.status, xhr.responseText);
					me.isUploading = false;
					me.uploadPromise = null;
					resolve(null);
				}
			};

			xhr.onerror = function(err) {
				console.error("❌ Video upload network error:", err);
				me.isUploading = false;
				me.uploadPromise = null;
				resolve(null);
			};

			xhr.send(formData);
		});

		return me.uploadPromise;
	}


	testManualUpload(){
		const me = this;
		console.log("🎥 Manual upload test triggered...");
		me.stopScreenRecording();

		setTimeout(() => {
			const chunks = (me.allMediaChunks && me.allMediaChunks.length > 0) ? me.allMediaChunks : (me.mediaChunks || []);
			if (!chunks || chunks.length === 0) {
				console.warn("⚠️ No video chunks captured yet! Please record for a few seconds first.");
				return;
			}

			const blob = new Blob(chunks, { type: 'video/webm' });
			console.log("🎥 Transmitting " + chunks.length + " chunks (" + blob.size + " bytes) to upload server...");

			me.uploadRecordedVideo(blob).then(res => {
				if (res && res.status === 'success') {
					console.log("✅ UPLOAD SUCCESS! Video saved on server as: " + res.filename + " (" + res.sizeBytes + " bytes)");
				} else {
					console.warn("⚠️ Server Response: ", res);
				}
			}).catch(err => {
				console.error("❌ Upload Error: " + err.message);
			});
		}, 300);
	}

handleManualVideoSubmit(e) {
		const me = this;
		console.log("📤 [ContestGetTest] Handling manual video submit trigger from header button...");

		const latestAlert = (me.alertManager && me.alertManager.hasAlerts())
			? me.alertManager.getHistory()[me.alertManager.getHistory().length - 1]
			: { alertType: 'MANUAL_SUBMIT', strikeNumber: me.alertManager ? me.alertManager.getStrikes() : 0, description: 'Manual submit trigger from header Post Video button' };

		let evidencePromise = null;

		if (me.circularBuffer) {
			const clip = me.circularBuffer.captureManualEvidence(latestAlert);
			if (clip) {
				console.log("🚀 [ContestGetTest] Manual evidence clip captured and upload initiated:", clip);
				evidencePromise = clip.uploadPromise || me.uploadAlertEvidence(clip.blob, clip.alertMeta || latestAlert, clip.markerOffsetSeconds || 0, clip);
			}
		}

		if (!evidencePromise && me.allMediaChunks && me.allMediaChunks.length > 0) {
			const blob = new Blob(me.allMediaChunks, { type: 'video/webm' });
			console.log("🚀 [ContestGetTest] Uploading master video blob via uploadRecordedVideo:", blob.size);
			evidencePromise = me.uploadRecordedVideo(blob);
		}

		if (evidencePromise) {
			evidencePromise.then(res => {
				console.log("✅ [ContestGetTest] Manual video submit completed successfully:", res);
				try {
					window.dispatchEvent(new CustomEvent('contestVideoSubmitCompleted', { detail: { status: 'success', response: res } }));
				} catch(err) {}
			}).catch(err => {
				console.error("❌ [ContestGetTest] Manual video submit error:", err);
				try {
					window.dispatchEvent(new CustomEvent('contestVideoSubmitCompleted', { detail: { status: 'error', error: err } }));
				} catch(e) {}
			});
		} else {
			console.warn("⚠️ [ContestGetTest] No video data currently available to upload.");
			try {
				window.dispatchEvent(new CustomEvent('contestVideoSubmitCompleted', { detail: { status: 'error', message: 'No video data' } }));
			} catch(e) {}
		}
	}

	uploadAlertEvidence(videoBlob, alertMeta, markerOffsetSeconds = 0, clipResult = null){
		const me = this;
		if (!videoBlob || !(videoBlob instanceof Blob)) return Promise.resolve(null);

		const topicInfo = me.props.topicInfoObj || {};
		const contestId = topicInfo.contestId || 0;
		const userTestId = topicInfo.userTestId || 0;
		const testId = topicInfo.testId || 0;
		const alertType = (alertMeta && alertMeta.alertType) ? alertMeta.alertType : 'ALERT';
		const strikeNumber = (alertMeta && alertMeta.strikeNumber) ? alertMeta.strikeNumber : 1;

		const clipIndex = (clipResult && clipResult.index) ? parseInt(clipResult.index) : ((alertMeta && alertMeta.clipIndex) ? parseInt(alertMeta.clipIndex) : ((window.videoUploadTracker && window.videoUploadTracker.videos) ? window.videoUploadTracker.videos.length + 1 : 1));

		// Check if clip is already being uploaded or already uploaded
		if (clipResult && clipResult.uploadPromise) {
			return clipResult.uploadPromise;
		}

		const videoFilename = `alert_${alertType}_strike_${strikeNumber}_contest_${contestId}_test_${testId}_${Date.now()}.webm`;
		const alertDesc = (alertMeta && alertMeta.description) ? alertMeta.description : (
			alertType === 'TAB_SWITCH' ? 'Student switched browser tabs or minimized window.' :
			alertType === 'WINDOW_BLUR' ? 'Test window lost focus (clicked outside or opened another app).' :
			alertType === 'FULLSCREEN_EXIT' ? 'Student exited full screen mode.' :
			alertType === 'MANUAL_SUBMIT' ? 'User triggered manual evidence video capture.' :
			`${alertType} alert detected.`
		);
		const durationSec = Math.round((clipResult && clipResult.totalDurationSeconds) ? clipResult.totalDurationSeconds : ((alertMeta && alertMeta.totalDurationSeconds) ? alertMeta.totalDurationSeconds : 0));

		// Register in window.videoUploadTracker
		if (!window.videoUploadTracker) {
			window.videoUploadTracker = {
				totalCreated: 0,
				totalUploaded: 0,
				pendingUploads: 0,
				failedUploads: 0,
				contestId: contestId,
				testId: testId,
				userTestId: userTestId,
				videos: [],
				getSummary: function() { return `${this.totalUploaded} of ${this.totalCreated} video(s) uploaded to server.`; },
				list: function() { if (console && console.table) console.table(this.videos); return this.getSummary(); }
			};
			window.uploadedVideos = window.videoUploadTracker.videos;
			window.uploadedVideosCount = 0;
		}

		let trackerRecord = window.videoUploadTracker.videos.find(v => v.clipIndex === clipIndex);
		if (!trackerRecord) {
			trackerRecord = {
				clipIndex: clipIndex,
				windowId: (clipResult && clipResult.windowId) || (alertMeta && alertMeta.windowId) || `win_${userTestId}_${Date.now()}`,
				isSplit: (clipResult && clipResult.isSplit !== undefined) ? !!clipResult.isSplit : (alertMeta && alertMeta.isSplit !== undefined ? !!alertMeta.isSplit : false),
				filename: videoFilename,
				sizeBytes: videoBlob.size,
				sizeFormatted: (videoBlob.size / (1024 * 1024)).toFixed(2) + ' MB',
				durationSeconds: durationSec,
				alertType: alertType,
				strikeNumber: parseInt(strikeNumber) || 1,
				markerOffsetSeconds: parseFloat(markerOffsetSeconds) || 0,
				status: 'uploading',
				createdAt: Date.now(),
				createdTime: new Date().toLocaleString(),
				uploadedAt: null,
				uploadedTime: null,
				serverResponse: null,
				blob: videoBlob,
				downloadUrl: null
			};
			try {
				trackerRecord.downloadUrl = URL.createObjectURL(videoBlob);
			} catch(e) {}
			window.videoUploadTracker.videos.push(trackerRecord);
			window.videoUploadTracker.totalCreated = window.videoUploadTracker.videos.length;
			window.videoUploadTracker.pendingUploads++;
		} else {
			trackerRecord.status = 'uploading';
			trackerRecord.filename = videoFilename;
		}

		const roundTestId = topicInfo.roundTestId ? parseInt(topicInfo.roundTestId) : (topicInfo.roundId ? parseInt(topicInfo.roundId) : 0);

		let incidentList = [];
		if (alertMeta && Array.isArray(alertMeta.incidents) && alertMeta.incidents.length > 0) {
			incidentList = alertMeta.incidents.map(inc => ({
				...inc,
				windowId: inc.windowId || (clipResult && clipResult.windowId) || `win_${userTestId}_${Date.now()}`,
				isSplit: inc.isSplit !== undefined ? !!inc.isSplit : false,
				video: inc.video ? {
					...inc.video,
					durationSeconds: Math.round(inc.video.durationSeconds || 0)
				} : inc.video
			}));
		} else {
			// Build structured alertList containing initial alert and all subsequent window extension alerts
			let alertList = [];
			if (clipResult && Array.isArray(clipResult.alertList) && clipResult.alertList.length > 0) {
				alertList = clipResult.alertList.map(a => ({
					alertType: a.alertType || alertType,
					alertDescription: a.alertDescription || a.description || alertDesc,
					markerOffsetSeconds: parseFloat(a.markerOffsetSeconds !== undefined ? a.markerOffsetSeconds : markerOffsetSeconds) || 0.0,
					timestamp: a.timestamp || Date.now(),
					elapsed: a.elapsed || (me.formatTime ? me.formatTime(me.state.recordingTime || 0) : '00:00'),
					testQuestionId: a.testQuestionId !== undefined ? a.testQuestionId : ((me.state.questionObj && me.state.questionObj.id) || me.state.currentQuesNo || 1),
					strikeNumber: parseInt(a.strikeNumber || strikeNumber) || 1
				}));
			} else {
				alertList = [{
					alertType: alertType,
					alertDescription: alertDesc,
					markerOffsetSeconds: parseFloat(markerOffsetSeconds) || 0.0,
					timestamp: (alertMeta && alertMeta.timestamp) || Date.now(),
					elapsed: (alertMeta && alertMeta.elapsed) || (me.formatTime ? me.formatTime(me.state.recordingTime || 0) : '00:00'),
					testQuestionId: (alertMeta && alertMeta.testQuestionId !== undefined) ? alertMeta.testQuestionId : ((me.state.questionObj && me.state.questionObj.id) || me.state.currentQuesNo || 1),
					strikeNumber: parseInt(strikeNumber) || 1
				}];
				if (alertMeta && Array.isArray(alertMeta.additionalAlerts)) {
					alertMeta.additionalAlerts.forEach(add => {
						const subMeta = add.alertMeta || add;
						alertList.push({
							alertType: subMeta.alertType || alertType,
							alertDescription: subMeta.alertDescription || subMeta.description || alertDesc,
							markerOffsetSeconds: parseFloat(add.offsetSeconds !== undefined ? add.offsetSeconds : (subMeta.markerOffsetSeconds || 0.0)),
							timestamp: subMeta.timestamp || Date.now(),
							elapsed: subMeta.elapsed || (me.formatTime ? me.formatTime(me.state.recordingTime || 0) : '00:00'),
							testQuestionId: subMeta.testQuestionId !== undefined ? subMeta.testQuestionId : ((me.state.questionObj && me.state.questionObj.id) || me.state.currentQuesNo || 1),
							strikeNumber: parseInt(subMeta.strikeNumber || strikeNumber) || 1
						});
					});
				}
			}

			const windowId = (clipResult && clipResult.windowId) || (alertMeta && alertMeta.windowId) || `win_${userTestId}_${(alertMeta && alertMeta.timestamp) || Date.now()}`;
			const isSplit = clipResult && clipResult.isSplit !== undefined ? !!clipResult.isSplit : (alertMeta && alertMeta.isSplit !== undefined ? !!alertMeta.isSplit : false);

			const incidentItem = {
				clipIndex: clipIndex,
				windowId: windowId,
				isSplit: isSplit,
				alertList: alertList,
				video: {
					filename: videoFilename,
					mimeType: videoBlob.type || 'video/webm',
					sizeBytes: videoBlob.size || 0,
					durationSeconds: durationSec,
					encoding: 'binary'
				}
			};
			incidentList.push(incidentItem);
		}

		const payloadDto = {
			contestId: parseInt(contestId) || 0,
			testId: parseInt(testId) || 0,
			userTestId: parseInt(userTestId) || 0,
			roundTestId: roundTestId,
			totalClips: incidentList.length,
			incidents: incidentList
		};

		const formData = new FormData();
		formData.append('video', videoBlob, videoFilename);
		formData.append('payload', JSON.stringify(payloadDto));
		formData.append('contestId', contestId);
		formData.append('userTestId', userTestId);
		formData.append('testId', testId);
		formData.append('alertType', alertType);
		formData.append('strikeNumber', strikeNumber);
		formData.append('markerOffsetSeconds', markerOffsetSeconds);

		console.log("🚨 [ContestGetTest] Uploading alert evidence clip with payload DTO:", { contestId, userTestId, testId, alertType, size: videoBlob.size, payloadDto });

		// Local IndexedDB caching fallback
		try {
			if (typeof indexedDB !== 'undefined') {
				const dbReq = indexedDB.open("ContestProctorDB", 2);
				dbReq.onupgradeneeded = function(e) {
					const db = e.target.result;
					if (!db.objectStoreNames.contains("recordings")) {
						db.createObjectStore("recordings");
					}
					if (!db.objectStoreNames.contains("alert_evidence_queue")) {
						db.createObjectStore("alert_evidence_queue");
					}
				};
				dbReq.onsuccess = function(e) {
					try {
						const db = e.target.result;
						const tx = db.transaction("alert_evidence_queue", "readwrite");
						const store = tx.objectStore("alert_evidence_queue");
						store.put({ blob: videoBlob, filename: videoFilename, payload: payloadDto, meta: alertMeta, marker: markerOffsetSeconds, time: Date.now() }, videoFilename);
					} catch(err) {}
				};
			}
		} catch(e) {}

		const uploadEndpoint = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.includes('local'))
			? (window.location.protocol + "//" + window.location.hostname + ":8701/uploadAlertEvidence")
			: "/api/contest/uploadAlertEvidence";

		const uploadPromise = new Promise((resolve) => {
			const xhr = new XMLHttpRequest();
			xhr.open('POST', uploadEndpoint, true);

			xhr.onload = function() {
				if (xhr.status >= 200 && xhr.status < 300) {
					try {
						const response = JSON.parse(xhr.responseText);
						console.log("✅ Alert evidence uploaded successfully:", response);

						// Update tracker record
						if (trackerRecord) {
							trackerRecord.status = 'uploaded';
							trackerRecord.uploadedAt = Date.now();
							trackerRecord.uploadedTime = new Date().toLocaleString();
							trackerRecord.serverResponse = response;
						}
						if (window.videoUploadTracker) {
							window.videoUploadTracker.totalUploaded = window.videoUploadTracker.videos.filter(v => v.status === 'uploaded').length;
							window.videoUploadTracker.pendingUploads = window.videoUploadTracker.videos.filter(v => v.status === 'uploading').length;
							window.uploadedVideosCount = window.videoUploadTracker.totalUploaded;
							window.uploadedVideos = window.videoUploadTracker.videos;
							console.log(`🎥 [VideoUploadTracker] Video #${clipIndex} uploaded to server successfully! (${window.videoUploadTracker.totalUploaded}/${window.videoUploadTracker.totalCreated} uploaded)`, window.videoUploadTracker);
						}

						resolve(response);
					} catch(e) {
						if (trackerRecord) {
							trackerRecord.status = 'uploaded';
							trackerRecord.uploadedAt = Date.now();
							trackerRecord.uploadedTime = new Date().toLocaleString();
							trackerRecord.serverResponse = { status: 'success', raw: xhr.responseText };
						}
						if (window.videoUploadTracker) {
							window.videoUploadTracker.totalUploaded = window.videoUploadTracker.videos.filter(v => v.status === 'uploaded').length;
							window.videoUploadTracker.pendingUploads = window.videoUploadTracker.videos.filter(v => v.status === 'uploading').length;
							window.uploadedVideosCount = window.videoUploadTracker.totalUploaded;
							window.uploadedVideos = window.videoUploadTracker.videos;
						}
						resolve({ status: 'success', raw: xhr.responseText });
					}
				} else {
					console.error("❌ Alert evidence upload failed:", xhr.status, xhr.responseText);
					if (trackerRecord) {
						trackerRecord.status = 'failed';
					}
					if (window.videoUploadTracker) {
						window.videoUploadTracker.failedUploads = window.videoUploadTracker.videos.filter(v => v.status === 'failed').length;
						window.videoUploadTracker.pendingUploads = window.videoUploadTracker.videos.filter(v => v.status === 'uploading').length;
					}
					resolve(null);
				}
			};

			xhr.onerror = function(err) {
				console.error("❌ Alert evidence upload network error:", err);
				if (trackerRecord) {
					trackerRecord.status = 'failed';
				}
				if (window.videoUploadTracker) {
					window.videoUploadTracker.failedUploads = window.videoUploadTracker.videos.filter(v => v.status === 'failed').length;
					window.videoUploadTracker.pendingUploads = window.videoUploadTracker.videos.filter(v => v.status === 'uploading').length;
				}
				resolve(null);
			};

			xhr.send(formData);
		});

		if (clipResult) {
			clipResult.uploadPromise = uploadPromise;
		}

		return uploadPromise;
	}

	formatTime(seconds){
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
	}
	initiateQuestionPulseTimer(){
		var me = this;
		this.intervalId = setInterval(() => {
			if(me.enableQuestionTrackTimer){	   	 		
				me.trackQuestionPulsed();
			}
		}, 30000);
	}
	trackQuestionPulsed(){
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testId,
				"snippet_id": this.currentSnippetId,
				"question_source":this.state.questionObj.questionSource,
				"attempt_no": this.attemptBeforeEvaluate
			}
			//this.initiateTrack("question_pulsed",trackObj);
		}catch(e){
		}
	}
	handleMessage(event){	
	//	console.log(event.origin+", "+this.iframeContentDomain);
	  /*if (event.origin !== this.iframeContentDomain) {
	    console.warn('Invalid origin:', event.origin);
	    return;
	}*/

	switch (event.data.name) {
		case 'renderingCompleted':
		this.setState({questionRendered:true,paginationDisabled:false});

		var endTime = new Date().getTime();
		var questionloadedTime = -1;
		if(this.questionLoadTime != null){
			questionloadedTime = endTime - this.questionLoadTime;
		}

		var trackingdummyObj = {};
		if(this.trackingQuestionObj !== undefined && typeof this.trackingQuestionObj === "object"){
			for(var key in this.trackingQuestionObj){
				trackingdummyObj[key] = this.trackingQuestionObj[key];
			}
		}

		trackingdummyObj["load_duration"] = questionloadedTime;		

		//this.initiateTrack("question_loaded",trackingdummyObj);
		this.questionLoadTime = null;
		questionloadedTime = null;


		if(this.questionAnswerStartTime == null){
			this.questionAnswerStartTime = new Date().getTime();
		}

		this.enableQuestionTrackTimer = true;	    	

		if(typeof this.props.resumeTimer === "function"){
			this.props.resumeTimer();
		}
		this.canMoveToNextQuestion = true;

		break;
		case 'userAnswer':
		this.handleUserAnswer(JSON.parse(event.data.params));
		break;
	    case 'pushedUserAnswer':  // enterkey event    	
	    if(this.state.testMode == 1){
	    		//if($("#evaluateBtn").hasClass("disabled")===false){	    			
	    			this.evalAndNavigate = false;
	    			this.evalAndSubmit = false;
	    			this.timeSpentAction = "Check";
	    			this.handleUserAnswer(JSON.parse(event.data.params));
	    		//}
	    	}else{
	    		if(this.state.questionEvaluated == false && this.isEvaluationGoing == false){	    			
	    			this.evalAndNavigate = false;
	    			this.evalAndSubmit = false;
	    			this.timeSpentAction = "Check";
	    			this.isEvaluationGoing = true;
	    			this.handleUserAnswer(JSON.parse(event.data.params));
	    		}
	    	}  
	    	break;
	    }
	}
	handleUserAnswer(userAnswer) {		 
		var me = this;
		var userAnswered = userAnswer.userAnswered;
		var userResponse =  userAnswer.userResponse;
		
		var topicInfoObj = this.props.topicInfoObj.questions[this.state.currentQuesNo-1];
		var testid = this.props.topicInfoObj.testId;
		var quesType = this.state.questionObj.questionType;
		var currrentAttempt = this.state.currentAttempt;
		var mcqRes = null;
		var fibRes = null;
		
		if(quesType === "mcq"){
			mcqRes = userResponse;
		}else{
			fibRes = userResponse;
		}
		
		me.setState({paginationDisabled:false});
		
		if(userAnswered === false){		
			if(me.state.testMode == 1){			
				
				if(this.evalAndSubmit){
					this.isEvaluationGoing = false;
					//me.trackTimeSpentInQuestion();
					me.completeTest();
					return;
				}
				
				if(userAnswer.partialAnswer){						
					this.isSubmitTriggered = false;
					this.evalAndNavigate = false;
					this.evalAndSubmit = false;
					this.isEvaluationGoing = false;
					return;
				}
				
			}else if(me.state.testMode == 2 && this.evalAndSubmit){
				//me.trackTimeSpentInQuestion();
				this.isEvaluationGoing = false;
				me.completeTest();
				return;
			}
		}
		
		if(userAnswered === false  && me.state.testMode != 1){
			me.prassoView.focus();
			this.isEvaluationGoing = false;
			return;
		}else{
			if(me.state.testMode != 1){
				if(me.state.questionObj.questionType == "mcq"){				
					if (!userResponse.isUserOptionCorrect) {
						me.chooseShowSolution(false,false,this.solutionResults);
						me.ShowHideSolution();
					}
					else{										
						me.chooseShowSolution(false,false,this.solutionResults);
						me.ShowHideSolution();
					}
				}
			}
		}

		const tempCurrentQues = me.getCurrentQuestionNo();
		//console.log(userAnswered,userResponse);
		var callBackSuccess = function(response){

			if(typeof me.props.resumeTimer === "function"){
				me.props.resumeTimer();
			}

			var data = response;
			var finalResult = true;
			me.isEvaluationGoing = false;
			me.canMoveToNextQuestion = true;
			var solutionResults = new Object();
			if(response!==null && response.data){

				if(response.data.answer && me.allQuestions && me.allQuestions.length > 1 ){
					//console.log("me.currentQuestionNo ",me.currentQuestionNo+" ",response.data.answer);
					let questions = me.allQuestions;
					let currQuesNo = me.currentQuestionNo;

					if(currQuesNo > 0){
						currQuesNo = (currQuesNo > 0) ? (currQuesNo-1) : 0
					}else{
						currQuesNo = (currQuesNo < 0) ? 0 : (currQuesNo-1);
					}

					me.allQuestions[currQuesNo].answer = response.data.answer;
				}				

				me.completedQuestionCnt = response.data.completedQnCount;
				me.seenQnCount = response.data.seenQnCount;
				me.setState({currentAttempt:response.data.currentAttempt});
				//,currentQuesNo:response.currentQNo
			}
			for(var res in data){
				finalResult = finalResult & data[res];
				solutionResults[res] = data[res];
			}
			
			if(me.state.questionObj.questionType == "fib"){	
				me.showSolution = false;
				me.correctAns = false;	
				me.setState({showSolution:false});
				me.chooseShowSolution(me.correctAns,me.showSolution,solutionResults);
				if(me.showSolution){
					if(me.state.testMode != 1){
						me.setScrollElement("answers-display");
					}
				}				
			}
			
			try{
				var trackingdummyObj = {};
				if(me.trackingQuestionObj !== undefined && typeof me.trackingQuestionObj === "object"){
					for(var key in me.trackingQuestionObj){
						trackingdummyObj[key] = me.trackingQuestionObj[key];
					}
				}

				trackingdummyObj["result"] = finalResult;
				trackingdummyObj["answered"] = (userAnswered === undefined) ? true : userAnswered;
				//me.initiateTrack("question_evaluated",trackingdummyObj);
			}catch(e){}

			
			me.setTmpQuestionNo(me.getCurrentQuestionNo());
			
			// let attempted = (response.data && response.data.attempted) ? response.data.attempted : false;
			// if(!me.attemptedQuestionIndices.has(tempCurrentQues) && attempted){
			// 	me.attemptedQuestionIndices.add(tempCurrentQues);
			// }else if(me.attemptedQuestionIndices.has(tempCurrentQues) && !attempted){
			// 	me.attemptedQuestionIndices.delete(tempCurrentQues);
			// }
			
			//console.warn("lalala::",me.attemptedQuestionIndices," : ",tempCurrentQues," , ",response.data);
			
			me.postEvaluation(finalResult, userAnswered);
			if(typeof me.temporaryCallBack === "function"){
				me.temporaryCallBack.apply(this);
			}
		}
		var callBackFailure = function(response){		
			if(typeof me.props.resumeTimer === "function"){
				me.props.resumeTimer();
			}

			me.canMoveToNextQuestion = true;
			me.isEvaluationGoing = false;
			console.log("QUESTION_EVALUATE Error : ", response);

			if(typeof me.temporaryCallBack === "function"){
				me.temporaryCallBack.apply(this);
			}
		}
		let contestId = this.props.topicInfoObj.contestId || 0;
		let roundTestId = this.props.topicInfoObj.roundTestId || 0;
		let userTestId = this.props.topicInfoObj.userTestId || 0;
		let testQuestionId = this.currentQuestionId || 0;
		let attemptNumber = this.state.currentAttempt || 0;
		let questionType  = quesType || '';
		let nextQuestionNo = (this.nextQuestionNo >= this.questionStart && this.nextQuestionNo <= this.totalNoQuestions) ? this.nextQuestionNo : this.totalNoQuestions;
			var userTestQnId = this.props.topicInfoObj.questions[nextQuestionNo-1].userTestQnId;
		

		let postParams = {
			"contestId":contestId,
			"roundTestId":roundTestId,
			"userTestId":userTestId,
			"testQuestionId":testQuestionId,
			"attemptNumber":attemptNumber,
			"fibUserResponse":fibRes,
			"mcqUserResponse":mcqRes,
			"questionType":questionType,
			"nextAttempt": {
				"userQuestionId" : userTestQnId,
				"attemptNumber" : 1
			}
		}		
		
		if(typeof me.props.callbackParent === "function"){
			postParams["time"] = window.btoa(me.props.callbackParent());
			console.log("QUESTION_EVALUATE ",me.props.callbackParent());
		}

		new HmAjax(this.getUrlFor("CONTEST_QUESTION_EVALUATE"),postParams).mask("ThreeDots").post(callBackSuccess,callBackFailure);

		this.canMoveToNextQuestion = false;
		if(typeof this.props.pauseTimer === "function"){
			this.props.pauseTimer();
		}		
	}
	postEvaluation(finalResult, userAnswered){
		var me = this;
		var topicInfoObj = this.props.topicInfoObj.questions[this.state.currentQuesNo-1];
		var currrentAttempt = this.state.currentAttempt;	
		
		me.setState({questionEvaluated:true});
		if(me.state.testMode == 1){	
			let questions = me.props.topicInfoObj.questions;

			if(me.state.pageCurrent>0){
				this.currentQuestionNo = (me.state.pageCurrent > questions.length) ? questions.length : me.state.pageCurrent;
			}else{
				this.currentQuestionNo = (me.state.pageCurrent < 0) ? 0 : me.state.pageCurrent;
			}

			me.currentQuestionId = me.props.topicInfoObj.questions[me.currentQuestionNo-1].questionId; 	
			
			me.setState({currentQuesNo:me.currentQuestionNo});

			if(userAnswered == false || userAnswered == "" ){
				delete this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt];
				me.setState({attemptedQuestions:this.submittedQnMap});	
				
			}else{
				this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt]=true;
				me.setState({attemptedQuestions:this.submittedQnMap});					
			}
			
			if(me.forceSubmit){
				this.evalAndSubmit = true;
				me.completeTest();
			}else if(this.isSubmitTriggered){
				me.showSubmitConfirm();
				this.isSubmitTriggered = false;			
			}else{
				if(this.evalAndNavigate){
					me.getQuestion();
				}
				else if(this.evalAndSubmit){
					me.completeTest();
				}
			}
			
			
		}else{
			
			if(finalResult == true){
				this.attemptsLeft = -1;
				this.currentAttempt = 1;
				this.currentQuestionNo++;
				this.completedQuestionCnt++;	
			}else{
				if (this.allowedAttempts < 1) {						
					this.currentAttempt++;
				} else {				
					this.attemptsLeft--;
					this.currentAttempt++;
					if (this.attemptsLeft > 0) {
						//$("#attemptsLeft").html(attemptsLeft.toString());
					} else if (this.attemptsLeft < 0) {
						this.attemptsLeft = -1;
						this.currentAttempt = 1;
						this.currentQuestionNo++;
					} else {
						//$("#attemptsLeft").html("-");
						this.attemptsLeft = -1;
						this.currentAttempt = 1;
						this.currentQuestionNo++;
					}
				}	
			}
			me.setState({currentAttempt:this.currentAttempt});
			console.log(this.currentQuestionNo,this.attemptsLeft,this.currentAttempt);
			if (this.currentQuestionNo > this.totalNoQuestions) {		
				me.setState({testCompleted:true});
				me.updateProgress();
				if(this.isAutoSubmitAllowed()){
					me.completeTest();
				}				
				return;
			}
		}		
		me.updateProgress();
	}
	chooseShowSolution(correctAns,showsolution,resultsObj){
		var me = this;
		if(me.state.testMode != 1){
			
			if(me.state.questionObj.questionType == "fib"){
				//this.prassoView.showSolution(false,showsolution,resultsObj);
				me.prassoView.postMessage({name:"showSolution",params:[false,showsolution,resultsObj]}, this.iframeContentDomain);
			}else{
				//this.prassoView.showSolution(false,showsolution);
				me.prassoView.postMessage({name:"showSolution",params:[false,showsolution]}, this.iframeContentDomain);
			}
			
			me.ShowHideSolution();
		}
	}
	ShowHideSolution(){
		
		if(this.showSolution){
			//$("#displaySolnStudent").html(btn_hidesolution);
		}else{
			//$("#displaySolnStudent").html(btn_viewsolution);
		}
	}
	setScrollElement(target){
		var me=this;
		setTimeout(function(){
			//this.prassoView.scrollToId(target);
			me.prassoView.postMessage({name:"scrollToId",params:[target]}, this.iframeContentDomain);
		}, 500);
	}
	modalCloseEvent(callBack=null){
		const me = this;

		const callBackSelf = () => {
			try{
				window.removeEventListener('message', me.handleMessage, false);
			}catch(e){}
			
			try{
				me.enableQuestionTrackTimer = false;
				clearInterval(me.intervalId);
			}catch(e){
				console.error("error while trying to close the timer", e);
			}

			try{
				
				me.timeSpentAction = "Close";
				if(me.isVisible($(".quesDispContainer"))==true){
				//	this.trackTimeSpentInQuestion();
				}
			}catch(e){
				console.error("Error::", e);
			}
			
			//this.trackTestClose();
			if(typeof callBack === "function"){
				callBack.apply(this);
			}
		}

		this.temporaryCallBack = callBackSelf;

		this.SaveClick();
	}
	trackTestClose(){
		var me = this;
		try{
			var postParams = {
				"trackingDefId" : 4,
				"testId" : this.props.topicInfoObj.testId,
				"endTime" : new Date().getTime()				
			}
			
			
			var callBackSuccess = function(response){
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_TEST_CLOSED");
			}

			new HmAjax(this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);
		}catch(e){}
		
	}
	isVisible(element) {
		var element = $(element);
		if (element.length > 0 && element.css('visibility') !== 'hidden' && element.css('display') !== 'none') {
			return true;
		} else {
			return false;
		}
	}
	trackTimeSpentInQuestion(){
		if(this.questionAnswerStartTime == null){
			return;
		}

		try{
			var endTime = new Date().getTime();
			this.questionAnswerElapsedTime = (endTime - this.questionAnswerStartTime);
			var postParams = {
				"trackingDefId" : 3,
				"testId" :  this.props.topicInfoObj.testId,
				"questionId" : this.currTestQuestionId,
				"snippetId" : this.currentSnippetId,
				"currQuestAtt" : this.state.currentAttempt,
				"sourceId" : this.state.questionObj.questionSource,
				"timeSpent" : this.questionAnswerElapsedTime,
				"startTime" : this.questionAnswerStartTime,
				"endTime" : endTime,
				"action" : this.timeSpentAction
			}
			
			var me = this;
			var callBackSuccess = function(response){
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_QUESTION_TIMESPENT");
			}

			new HmAjax(this.getUrlFor("TRACK_QUESTION_TIMESPENT"),postParams).post(callBackSuccess,callBackFailure);
			
			this.questionAnswerStartTime = new Date().getTime();
			this.enableQuestionTrackTimer = false;
		}
		catch(e){}
	}

	getQuestion(){
	   this.allQuestions = (this.props.topicInfoObj && this.props.topicInfoObj.questions && this.props.topicInfoObj.questions.length>0) ? this.props.topicInfoObj.questions : [];
	   this.isEvaluationGoing = false;
	   this.setState({paginationDisabled:true,questionRendered:false,questionEvaluated:false,currentAttempt:this.currentAttempt,currentQuesNo:this.currentQuestionNo,showSolution:false});
	   var me = this;
	   this.questionAnswerStartTime = null;
	   this.enableQuestionTrackTimer = false;
	   this.currentRating = null;
	   var topicQuesObj = this.props.topicInfoObj.questions[this.currentQuestionNo-1];
	   var testid = this.props.topicInfoObj.testId;
	   let getQuestionURL = "";
	   this.allowedAttempts = topicQuesObj.maxAttempts;
	   this.currTestQuestionId  = topicQuesObj.questionId;
	   this.currentSnippetId = topicQuesObj.snippetId;

		if (this.allowedAttempts > 0) {
			
			if (this.attemptsLeft == -1) {
				this.attemptsLeft = this.allowedAttempts - (this.currentAttempt - 1);
			}
		} 
		
		this.attemptBeforeEvaluate = this.state.currentAttempt;
		
		
		var callBackSuccess = function(response){	

			let dataJsonList = response.data;
			let dataQuestion = dataJsonList;		
			//if(me.state.testMode == 1){
				dataQuestion = dataQuestion.questionContainer;
			//}
			me.setState({questionObj:dataQuestion});
			//console.log(dataJsonList.answer);
			me.prassoView.postMessage({name:"loadQuestion",params:[dataQuestion.question, dataJsonList.answer]}, me.iframeContentDomain);
			
			me.container.scrollTop = 0;
			me.updateProgress();
			me.checkImageLoaded();
		}

		var callBackFailure = function(response){
			this.questionLoadTime = null;
			me.setState({paginationDisabled:false});
			console.log("GET_QUESTION Error : ", response);
		}
		
		let contestId = this.props.topicInfoObj.contestId || 0;
		let roundTestId = this.props.topicInfoObj.roundTestId || 0;
		let userTestId = this.props.topicInfoObj.userTestId || 0;
		let testQuestionId = this.currentQuestionId || 0;
		let attemptNumber = this.state.currentAttempt || 0;


		if(this.allQuestions && this.allQuestions.length > 1 && this.allQuestions[1].questionContainer){
			callBackSuccess.apply(this, [{"data":me.allQuestions[(me.currentQuestionNo > 0) ? me.currentQuestionNo-1 : 0]}]);
		}else{
			new HmAjax(this.getUrlFor("CONTEST_GET_QUESTION")+"?contestId="+contestId+"&roundTestId="+roundTestId+"&userTestId="+userTestId+"&testQuestionId="+testQuestionId+"&attemptNumber="+attemptNumber).get(callBackSuccess,callBackFailure);
		}
		
		
		if(this.questionLoadTime == null){
			this.questionLoadTime = new Date().getTime();
		}
		this.trackingQuestionObj = {
			"test_id": testid,
			"snippet_id": this.currentSnippetId,
			"question_source":topicQuesObj.source,
			"attempt_no": this.state.currentAttempt
		}
	}
	submitClick(forceSubmit){
		this.forceSubmit = (forceSubmit === true) ? true : false;
		var me = this;
		this.isSubmitTriggered = true;
		this.timeSpentAction = "Submit";
		var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt; //this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		//console.log("unattemptedQuestionCount="+unattemptedQuestionCount);
	   /*if(unattemptedQuestionCount > 0){
			this.triggerGetUserAnswer(); 	
		}else{
			this.showSubmitConfirm();
		}	*/
		this.triggerGetUserAnswer(); 	
	}
	submitPractice(){
		this.isSubmitTriggered = false;
		this.evalAndNavigate = false;
		this.evalAndSubmit = true;

		this.completeTest();

		return;
		/**
		*IMPORTANT: Following block may have been written for a purpose which is unknown for the present devs.
		* Hence, commenting the code below. Should there be any unwanted scenarios, please check before uncommenting the following code.
		*/
	/**	var testId = this.props.topicInfoObj.testId;
		let testType = this.props.topicInfoObj.testType;

		var trackObj = {
			"test_id": testId,
			"submitted": true
		}		
		this.storeTrackEvent("test_closed", trackObj);

		this.timeSpentAction = "Submit";
		this.trackTimeSpentInQuestion();
		this.trackTestClose();

		let redirectUrl = "/scorecard/"+testId;
		if(testType === 5 || testType === 6){
			//window.location.href="/800";
			redirectUrl = "/report";
		}

		setTimeout(function(){
			window.location.href = redirectUrl;
		},500)
	*/
	}
	triggerGetUserAnswer(){
		this.evalAndNavigate = false;
		this.evalAndSubmit = false;
		this.evalAns();
	}
	showSubmitConfirm(){
		var me = this;
		var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt;//Object.keys(this.submittedQnMap).length;
		var msg = "";
		if(typeof me.props.resumeTimer === "function"){
			me.props.resumeTimer();
		}
		this.canMoveToNextQuestion = true;
		if(unattemptedQuestionCount > 0){
		   //msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
		   msg = this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);
		}else{
			msg = this.rb("test.confirm.allanswered");
		}
		confirmAlert({
			title: this.rb("test.confirm.wanttosubmit"),
			message: msg,
			buttons: [
				{
					label: this.rb("alert.no"),
					onClick: () => {
						this.isSubmitTriggered = false;
		
		
					}
				},
					{
						label: this.rb("alert.ok"),
						onClick: () => {
							this.isSubmitTriggered = false;
							this.evalAndNavigate = false;
							this.evalAndSubmit = true;
						//me.evalAns();
						me.completeTest();
					}
				}	
		]
	});	  
	}
	showAutoSubmitConfirm(callback, response){
		var me = this;
		var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt; //this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		var msg = "";
		if(unattemptedQuestionCount > 0){
			//msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
			msg = this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);
		}else{
			msg = this.rb("test.confirm.allanswered");
		}
		confirmAlert({
			title: this.rb("test.confirm.autosubmit"),
			message: msg,
			buttons: [
			{
				label: this.rb("alert.autosubmit.ok"),
				onClick: () => {
					if(typeof callback === "function"){
						callback.apply(this,[response]);
					}
			/* 	this.isSubmitTriggered = false;
				this.evalAndNavigate = false;
				this.evalAndSubmit = true;
				//me.evalAns();
				me.completeTest(); */ //not commented
			}
		}
		],
		closeOnClickOutside : false
	});	  
	}
	completeTest(isScoreCard=false){	  
		var me = this;
		me.isSubmitting = true;

		var testId = me.props.topicInfoObj.testId;
		var testType = me.props.topicInfoObj.testType;
		var contestHost = me.getContestHost();

		let finalCallBack = function(response){
			me.prassoView.postMessage({name:"disableInput"}, me.iframeContentDomain);

			let doRedirect = function() {
				let redirectUrlByType = (window.cont_test_type_submit_route) ? window.cont_test_type_submit_route[contestHost] : null;

				if(redirectUrlByType){
					window.location.href=redirectUrlByType;
				}else if(me.state.testMode == 1 || isScoreCard || !redirectUrlByType){
					//console.log("testId22="+testId)
					var trackObj = {
						"test_id": testId,
						"submitted":true
					}
					me.storeTrackEvent("test_closed", trackObj);
					//me.trackTestClose(); 

					window.location.href="/scorecard/"+testId;

				}
				if(typeof me.props.closeTimer === "function"){
					me.props.closeTimer();
				}
			};

			console.log("🎥 Finalizing screen recording & uploading master video on submission...");
			try {
				me.stopScreenRecording();
			} catch(e) {}

			setTimeout(doRedirect, 1500);
		}

		var callBackSuccess = function(response){	
			if(me.forceSubmit){
				me.showAutoSubmitConfirm(finalCallBack, response);
			}else{
				finalCallBack(response); 
			}			
		}

		var callBackFailure = function(response){	
			me.isAjaxSubmitTriggered = false;
			console.log("SUBMIT_TEST Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}		
		
		var postParams={			
			"contestId":this.props.topicInfoObj.contestId,
			"roundTestId":this.props.topicInfoObj.roundTestId,
			"userTestId":this.props.topicInfoObj.userTestId
		}

		if(typeof me.props.callbackParent === "function"){
			postParams["time"] = window.btoa(me.props.callbackParent());
			//console.log("submit test ",this.props.callbackParent());
		}

		if(!this.isAjaxSubmitTriggered){
			this.isAjaxSubmitTriggered = true;
			new HmAjax(this.getUrlFor("CONTEST_SUBMIT_TEST"),postParams).post(callBackSuccess,callBackFailure);
		}	
		
		// var postParams={			
		// 	"testId":testId,
		// 	"revisionTestId":this.props.revisiontestid,
		// 	"topicSubtopicMapId":this.props.topicsubtopicId
		// }

		// if(typeof me.props.callbackParent === "function"){
		// 	postParams["time"] = window.btoa(me.props.callbackParent());
		// 	//console.log("submit test ",this.props.callbackParent());
		// }

		// if(!this.isAjaxSubmitTriggered){
		// 	this.isAjaxSubmitTriggered = true;
		// 	new HmAjax(this.getUrlFor("SUBMIT_TEST"),postParams).put(callBackSuccess,callBackFailure);
		// }		
		
	}
	updateProgress() {	
		var percentComplete = 0 ;
		if(this.state.testMode == 1){
			percentComplete = Math.round((this.completedQuestionCnt / this.state.totalQuestions) * 100); //Math.round(((Object.keys(this.submittedQnMap).length) / this.state.totalQuestions) * 100);
		}else{
			percentComplete = Math.round(((this.currentQuestionNo-1) / this.totalNoQuestions) * 100); //Math.round(((this.currentQuestionNo-1) / this.totalNoQuestions) * 100);
		}
		
		this.setState({percentageComplete:percentComplete});		
	}
	EvaluateClick(){
		if(this.isEvaluationGoing == false){
			this.evalAndNavigate = false;
			this.evalAndSubmit = false;	
			this.isEvaluationGoing = true;
			this.timeSpentAction = "Check";
			this.evalAns();
		}
	}
	SaveClick(){
		if(this.isEvaluationGoing == false){
			let currClickQues = this.getCurrentQuestionNo();
			this.nextQuestionNo = currClickQues;

			this.evalAndNavigate = false;
			this.evalAndSubmit = false;	
			this.isEvaluationGoing = true;
			this.timeSpentAction = "Save";
			this.evalAns();
		}
	}
	PrevClick(){
		if(this.canMoveToNextQuestion){
			this.prevchangeEvent();	
		}else{
			console.warn("cannot move to previous question until current one is rendered.");
		}		
	}
	NextClick(){
		// this.getQuestion();
		// this.timeSpentAction = "Next";
		// var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt; //this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		// console.log("unattemptedQuestionCount="+unattemptedQuestionCount);
		// this.triggerGetUserAnswer(); 
		if(this.canMoveToNextQuestion){	
			this.changeEvent();
		}else{
			console.warn("cannot move to next question until current one is rendered.");
		}
	}
	viewHideSolutionClick(){
		this.showSolution = !this.showSolution;		
		this.chooseShowSolution(this.correctAns,this.showSolution,this.solutionResults);
		this.setState({showSolution:this.showSolution});
		if(this.showSolution){
			this.setScrollElement("solution-display");
		}else{
			this.setScrollElement("question-display");			
		}
		
		this.trackShowHideSolution(this.showSolution);
		this.checkImageLoaded();
	}
	trackShowHideSolution(showSol){
		var myaction = "";

		if(showSol == true){
			myaction = "Open";
		}else{
			myaction = "Close";			
		}
		var postParams = {
			trackingDefId: 1,
			testId : this.props.topicInfoObj.testId,
			questionId : this.currTestQuestionId,
			snippetId : this.currentSnippetId,			
			currQuestAtt : this.state.currentAttempt,
			sourceId : this.state.questionObj.questionSource,
			action : myaction
		}
		
		var me = this;
		var callBackSuccess = function(response){
			
		}

		var callBackFailure = function(error){
			console.log("Error in TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
		
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testId,
				"snippet_id": this.currentSnippetId,
				"question_source":this.state.questionObj.questionSource,
				"item_type": this.getTracker().enums.viewedItemType.solution,
				"hidden": !showSol
			}
			//this.initiateTrack("item_viewed",trackObj);
		}catch(e){
		}
	}
	getStatusText(){
		if(this.props.topicInfoObj.status == "IN_PROGRESS"){
			return this.rb("home.continue");
		}else{
			return "Start Practice";
		}
	}
	getStatusActionText(){	  


		if(this.props.subtopic){
			if(this.props.subtopic.status == "IN_PROGRESS"){
				if(this.props.subtopic.testStatus == "COMPLETED" && this.props.subtopic.reqTestStatus != "COMPLETED"){
					if(this.props.subtopic.reqTestStatus == "IN_PROGRESS"){
						return this.rb("home.resume");	
					}else{
						return this.rb("home.start");
					}
				}

				return this.rb("home.resume");			
			}else if(this.props.subtopic.status == "COMPLETED"){
				return "";
				
			}else{
				return this.rb("home.start");
			}
		}else if(this.props.studentStatus){
			if (this.props.studentStatus === "IN_PROGRESS") {
				return this.rb("home.resume");
			} else {
				return this.rb("home.start");
			}
		}
	}
	getviewhideText(){
		if(this.state.showSolution){
			return this.rb("test.hidesolution");
		}else{
			return this.rb("test.viewsolution");
		}
	}

	getPagination = () => {
		if(this.state.pageTotal>1){
			let siblingPagesRange =  (this.isTab() || this.isMobile()) ? 1 : 3;
		return(
			<Fragment>
				{
					(() => {
						let disabledBtn = !this.state.questionRendered;
						if(this.currentQuestionNo <= this.questionStart){
							disabledBtn = true
						}
						return(
							<button type="button" className="btn btn-primary mediumBtn navgbtn prevbtn" disabled={disabledBtn} onClick={this.PrevClick}>
								<i className="material-icons">chevron_left</i> {this.rb("test.prev")}
							</button>
						)
					})()
				}
				<Pagination
					currentPage={this.state.currentQuesNo}
					totalPages={this.state.pageTotal}
					boundaryPagesRange={1}
					siblingPagesRange={siblingPagesRange}
					hidePreviousAndNextPageLinks={true}
					hideFirstAndLastPageLinks={true}
					hideEllipsis={false}
					onChange={this.onPageChange}
					disabled={this.state.paginationDisabled}
				/>

				{
					(() => {
						let disabledBtn = !this.state.questionRendered;
						if(this.currentQuestionNo >= this.totalNoQuestions){
							disabledBtn = true
						}
						return(
							<button type="button" className="btn btn-primary mediumBtn navgbtn nxtbtn" disabled={disabledBtn} onClick={this.NextClick}>
								{this.rb("test.next")} <i className="material-icons">chevron_right</i>
							</button>
						)
					})()
				}
			</Fragment>
		)
		}
	}

	renderBottomSection(){
		//console.log("this.props.topicInfoObj:::",this.props.topicInfoObj);
		
		return(
			<MuiThemeProvider>
			<div className="col-12 row nopadding">				

			{(() => {
				if(this.state.testMode == 1){		
					return(
						<div className="col-12 row nopadding contest_get_test">	

						<div className="flex-container">
								<div className="savedivbtn">
									<button type="button" className="btn btn-primary mediumBtn savebtn" data-ga="Student- test taking - save button" disabled={!this.state.questionRendered} onClick={this.SaveClick}>
									{this.rb("test.save")}
									</button>
								</div>
								<div className="paginationbtn">
									{this.getPagination()}
								</div>
								<div className="submitbtn">
									{
										(() => {
											let disabledBtn = !this.state.questionRendered;
											if(this.seenQnCount < this.totalNoQuestions){
												disabledBtn = true
											}
											disabledBtn = false
											return(
											<div className="submittestbtndiv">
												<button type="button" className="btn btn-primary mediumBtn subbutton" data-ga="Student- test taking - submit button" disabled={disabledBtn} onClick={this.submitClick}>
												{this.rb("test.submittest")}
												</button>
											</div>
											)
										})()
									}
								</div>
							</div>
						</div>
						)
				}else{
					if(this.state.questionEvaluated == false){
						return(
							<div className="col-12 row">	
							<div className="col-12 col-sm-12">											
							<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered && !this.isEvaluationGoing} onClick={this.EvaluateClick}>
							{this.rb("test.check")}
							</button>	
							</div>										 
							</div>
							)
						}else{
							return(
							<div className="col-12 row">	
							<div className="col-12 col-sm-12 nopadding">		
							{(() => {
								if(this.state.testCompleted){
									return(
									<button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" disabled={!this.state.questionRendered} onClick={this.submitPractice}>
									{this.rb("test.submit")}
									</button>	
									);
								} else{
									return(
									<button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" disabled={!this.state.questionRendered} onClick={this.NextClick}>
									{this.rb("test.next")}
									</button>	
									);
								}											 				
							})()}

							<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.viewHideSolutionClick}>
							{(() => {
								if(this.state.showSolution){return (<div>{this.rb("test.hidesolution")}</div>)} else{return (<div>{this.rb("test.viewsolution")}</div>)}											 				
							})()}											 			
						</button>
						</div>										 
						</div>
						)
					}

				}
			})()}

			</div>
			</MuiThemeProvider>
			);
		}

		updateQuestionDisplay(){
			return(
				<div className="questionsDisp float-right">
				{(() => {
					if(this.state.testMode == 1){		
						return(
							<h5><span>Questions Attempted:&nbsp;</span> {this.completedQuestionCnt} <span>&nbsp;of&nbsp;</span> {this.props.topicInfoObj.questionCount} </h5>
						// <h5>{this.state.percentageComplete}% {this.rb("test.complete")} </h5>
						)
					}
					// else{						
					// 	return(
					// 	<h5>{this.state.percentageComplete}% {this.rb("test.complete")} &nbsp; | &nbsp;{this.rb("test.attemptsleft")}: {(this.attemptsLeft<0)?0:this.attemptsLeft} </h5>
					// 	)
					// }
				})()}
				</div>
				);
		}

		updatePercentageDisplay(){


			return(
			<div className="percentageDisp float-right">
			{(() => {
				if(this.state.testMode == 1){		
					return(
					<h5>{this.state.percentageComplete}% {this.rb("test.complete")} </h5>
					)
				}else{						
					return(
					<h5>{this.state.percentageComplete}% {this.rb("test.complete")} &nbsp; | &nbsp;{this.rb("test.attemptsleft")}: {(this.attemptsLeft<0)?0:this.attemptsLeft} </h5>
					)
				}
			})()}
			</div>
			);
		}
		likeFn(event){
			if($(event.currentTarget).hasClass("selected")){
				return false;
			}
			const ratingIcons = document.querySelectorAll('.ratingIcon');
			ratingIcons.forEach(rating => {
				rating.classList.remove('selected');
			})
			event.currentTarget.classList.add("selected");

			var postParams = {
				trackingDefId: 2,
				testId : this.props.topicInfoObj.testId,
				questionId : this.currTestQuestionId,
				snippetId : this.currentSnippetId,
				rating : parseInt($(event.currentTarget).attr("data-id")), 
				currQuestAtt : this.state.currentAttempt,
				sourceId : this.state.questionObj.questionSource,
				action : "submit"
			}
			this.currentRating = parseInt($(event.currentTarget).attr("data-id"));
			var me = this;
			var callBackSuccess = function(response){
				$(".likebox").attr("data-myrating",this.currentRating);
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_SOLUTION");
			}

			new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);


			try{
				var trackObj = {
					"test_id": this.props.topicInfoObj.testId,
					"snippet_id": this.currentSnippetId,
					"question_source":this.state.questionObj.questionSource,
					"attempt_no": this.attemptBeforeEvaluate,
					"helpful": parseInt($(event.currentTarget).attr("data-id")) === 2,
					"source":this.getTracker().enums.itemRatedSource.test
				}
				//this.initiateTrack("solution_rated",trackObj);
			}catch(e){
			}


		}
		setRatingSelected(id){
			if(this.currentRating != null){
				if(this.currentRating == id){
					return "selected";
				}
			}
		}
		renderRatingContainer() {
			if(this.state.showSolution){
				return (
				<div className="likebox" data-myrating="0">
				<p>{this.rb("rating.title")}</p>
				<div className="btngp">
				<span className={"ratingIcon "+this.setRatingSelected(2)} data-id="2" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_up</i></span>
				<span className={"ratingIcon "+this.setRatingSelected(1)} data-id="1" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_down</i></span>
				</div>
				</div>
				)
			}
		}
		checkImageLoaded(){	
			try{
				$('img').unbind("error");
				$('img').error(function(){		
					var me = this;
					var timeDelay = 5000;

					if(!$(me).attr('imageReloadCount')){
						$(me).attr('imageReloadCount',1);
					}

					timeDelay = timeDelay * parseInt($(me).attr('imageReloadCount'));			

					setTimeout(function()
					{ 				
						if(!$(me).attr('imageReloadCount')){
							$(me).attr('imageReloadCount',1);
						}else{
							$(me).attr('imageReloadCount',parseInt($(me).attr('imageReloadCount'))+1);
						}

						if($(me).attr('imageReloadCount')<=4){
							//console.log("timeDelay::",timeDelay);
							$(me).attr('src',$(me).attr('src'));
						}

						if(console){
							console.log("image not loaded :"+$(me).attr('src'));			
						}

					}, timeDelay);		

				}).load(function(){
					//console.log("loaded successfully...");
				});
			}
			catch(e){

			}

		}
		render = () => {
			let me = this;
			return(				
			<div className="row modalBase testTakingScreen">

			{!this.state.isRecording && (
				<div className="screen-recording-lock-overlay" style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100vw',
					height: '100vh',
					backgroundColor: 'rgba(15, 23, 42, 0.95)',
					backdropFilter: 'blur(10px)',
					zIndex: 99999,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					color: '#ffffff',
					textAlign: 'center',
					padding: '30px'
				}}>
					<div style={{ fontSize: '64px', marginBottom: '15px' }}>🔒</div>
					<h2 style={{ color: '#ef4444', fontWeight: 'bold', marginBottom: '15px', fontSize: '24px' }}>
						Test Paused: Screen Sharing Required
					</h2>
					<p style={{ maxWidth: '560px', fontSize: '15px', color: '#cbd5e1', lineHeight: '1.6', marginBottom: '25px' }}>
						Screen recording was stopped. To maintain test integrity, question content and navigation are locked until screen sharing is resumed.
					</p>
					{this.state.recordingError && (
						<div className="alert alert-warning mb-4" style={{ maxWidth: '600px', fontSize: '13px', fontWeight: '500', color: '#854d0e', backgroundColor: '#fef9c3', border: '1px solid #fde047', borderRadius: '8px' }}>
							⚠️ {this.state.recordingError}
						</div>
					)}
					<button 
						className="btn btn-danger btn-lg px-4 py-2" 
						style={{ fontWeight: 'bold', fontSize: '16px', borderRadius: '30px', boxShadow: '0 4px 20px rgba(239, 68, 68, 0.4)', cursor: 'pointer' }}
						onClick={() => this.startScreenRecording()}
					>
						🔴 Resume Screen Sharing (Entire Screen)
					</button>
				</div>
			)}

			<div className="col-12 quesDispContainer">
			<div className="clearfix">
			<div className="quesNumDisp float-left"><div> Question&nbsp;{this.state.currentQuesNo}</div></div>

			{this.state.showDebugUploadButton && (
				<button 
					type="button" 
					className="btn btn-sm btn-warning float-left ml-3 mt-1" 
					style={{ fontWeight: 'bold', zIndex: 100000 }}
					onClick={this.testManualUpload}
				>
					🎥 Debug: Stop & Upload Video
				</button>
			)}
			{this.updateQuestionDisplay()}
			{/* {this.updatePercentageDisplay()} */}
			{/* <div className="float-right"><CircularProgressbar percentage={ this.state.percentageComplete}  styles={{
				path: { stroke: 'rgba(62, 152, 199, ${this.state.percentageComplete / 100})' },
			}}/></div> */}
			</div>
			<Iframe url={this.getBasePath() + "/prassoapp/20171102/"}
			ref = {e => {
				me.container = e;
			}}
			position="relative"
			id="quesIframe"
			width="100%"				            
			className="quesIframe"
			onError={()=>{debugger;}}
			height="100%"				            
			styles={{height: "63vh"}}					
			allowFullScreen/>
			</div>


			{this.renderRatingContainer()}

			{this.renderBottomSection()}					
			</div>
			);
		}
	}

	export default ContestGetTest;


// WEBPACK FOOTER //
// ./src/views/contest/ContestGetTest.js